<template>
  <v-tooltip top :disabled="!tooltip">
    <template v-slot:activator="{ on }">
      <v-fab-transition>
        <v-btn
          v-on="on"
          v-bind="$attrs"
          :icon="!!icon && !label"
          :label="label"
          :color="color"
          :outlined="icon && !!label"
          :text="!icon"
          @click.prevent="$emit('click', $event)"
          rounded
        >
          <v-icon v-if="icon" :left="!!label" :center="!label" v-text="icon" />
          <span v-if="label" v-text="label" />
        </v-btn>
      </v-fab-transition>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CPTBtn",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    tooltip: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },

  data: () => ({})
};
</script>
